import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";
import GenericFlowExport from "./export-tables/generic-flow-export.jsx";
import TableBody from "./table-body.jsx";

const AmountDataset = ({ data }) => {
    const accumulatedDatasets = data?.accumulatedDatasets || [];

    useEffect(() => {
        const labels = accumulatedDatasets[0]?.data.map(e => e.time) || [];

        const dataColumns = accumulatedDatasets.map(averageDataset => {
            const values = averageDataset.data.map(e => parseFloat(e.qty) || 0);

            return [averageDataset.title, ...values];
        });
        GraphicUtils.lineChart(`traffic-flow-amount`, dataColumns, labels, "Intervalo de horas", "Quantidade acumulada de veículos", false, 999);

        const hasAnyData = accumulatedDatasets.some(dataset => dataset.data.some(e => parseFloat(e.qty) > 0));
        if (hasAnyData) {
            ReportUtils.createExportableTable(null, null, `Fluxo veicular acumulado`, "amount-export");
        }
    }, [data])

    return (
        <>
            <TableBody title={"Fluxo veicular acumulado por hora"} id={"traffic-flow-amount"}/>

            <GenericFlowExport datasets={accumulatedDatasets} flow={"Acumulado"} sheetName={"amount-export"}/>
        </>
    );
};

export default AmountDataset;